import { render, staticRenderFns } from "./CustomerCard.vue?vue&type=template&id=b28d6804&scoped=true&"
import script from "./CustomerCard.vue?vue&type=script&lang=js&"
export * from "./CustomerCard.vue?vue&type=script&lang=js&"
import style0 from "./CustomerCard.vue?vue&type=style&index=0&id=b28d6804&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b28d6804",
  null
  
)

export default component.exports